export default __webpack_public_path__ + "5349e31c16ce53f7de28f68ccede4b9a.png";